import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToIdWithHeaderOffset } from "@/lib/scroll";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Reset first to avoid showing an intermediate position during navigation.
      window.scrollTo({ top: 0, behavior: "auto" });
      scrollToIdWithHeaderOffset(hash.replace(/^#/, ""), { behavior: "smooth", extraOffsetPx: 8 });
      return;
    }

    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;

